<template>
  <div class="px-15">
    <div v-if="showloading" class="text-center">
      <v-progress-circular style="position: absolute; width: 25%; height: 25%; top: 50%; left: 50%; transform: translate(-50%, -50%)" indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <div>
        <div>Card Information</div>
        <stripe-element-card ref="elementRef" v-if="publishableKey" :pk="publishableKey" :tokenData="tokenData" @token="tokenCreated" hidePostalCode />
      </div>
      <div class="py-5">
        <div>Billing Address</div>
        <div class="pb-3">
          <div class="pb-1 pt-2">Country</div>
          <select class="w-100 pa-2 cardAddress" v-model="cardAddress">
            <template v-for="(x, index) in countries">
              <option class="px-5" :key="index" :value="index">{{ x.name }}</option>
            </template>
          </select>
        </div>
        <div class="pb-3">
          <div class="pb-1 pt-2">Zip Code</div>
          <input
            maxlength="5"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            class="w-100 pa-2 cardZipCode"
            type="number"
            v-model="cardZipCode"
          />
        </div>
      </div>
      <v-dialog v-model="errorDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 errorTitle">Unsuccessful</v-card-title>

          <v-card-text class="pt-3 errorDetail">{{ errorMsg }}</v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary " text @click="errorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { StripeElementCard } from '@vue-stripe/vue-stripe'
import countries from '@/countries.json'
import Config from '@/config.json'

export default {
  name: 'PaymentCard',
  props: {
    cardPaymentObj: {
      defualt: () => {}
    }
  },
  components: { StripeElementCard },
  data: () => ({
    publishableKey: Config.VUE_APP_STRIPE,
    token: null,
    cardNumber: null,
    cardExpiry: null,
    cardCvc: null,
    countries: countries,
    cardAddress: 'MY',
    cardZipCode: '',
    errorMsg: '',
    showloading: false,
    errorDialog: false
  }),
  computed: {
    tokenData() {
      let tokenData = {
        address_country: this.cardAddress,
        address_zip: this.cardZipCode
      }
      return tokenData
    }
  },
  mounted() {},
  methods: {
    submit() {
      this.$refs.elementRef.submit()
    },
    tokenCreated(token) {
      this.showloading = true

      this.token = token
      this.confirmPayment()
      // handle the token
      // send it to your server
    },
    confirmPayment() {
      this.$refs.elementRef.stripe
        .confirmCardPayment(this.cardPaymentObj.client_secret, {
          payment_method: {
            card: {
              token: this.token.id
            }
          }
        })
        .then((result) => {
          this.showloading = false

          if (result?.paymentIntent?.status == 'succeeded') {
            this.$emit('payment-succeess')
          } else {
            console.log(result.error.message)
            this.errorDialog = true
            this.errorMsg = result.error.message
          }
        })
    }
  }
}
</script>

<style scoped>
#custom-button {
  height: 30px;
  outline: 1px solid grey;
  background-color: green;
  padding: 5px;
  color: white;
}

#card-error {
  color: red;
}

.cardAddress {
  border: solid var(--v-primary-lighten1) 1px;
  appearance: auto;
}

.cardZipCode {
  border: solid var(--v-primary-lighten1) 1px;
}

input::-webkit-inner-spin-button {
  appearance: none !important;
}

.errorTitle {
  background: var(--v-primary-lighten1);
  color: #fff;
}
.errorDetail {
  color: #000 !important;
}
</style>
